import * as React from 'react';
import Svg, { Path, Rect, SvgProps } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = (props: SvgProps) => (
    <Svg width={props.width ?? 24} height={props.height ?? 24} viewBox="0 0 24 24" {...props} fill="none">
        <Rect
            x={3.60001}
            y={3.59961}
            width={16.8}
            height={16.8}
            rx={3.6}
            stroke={props.fill || designSystem.colors.neutral300}
            strokeWidth={1.75}
        />
        <Path d="M7.2 8.40039H15.6" stroke={props.fill || designSystem.colors.neutral300} strokeWidth={1.75} />
        <Path d="M7.2 15.5996H14.4" stroke={props.fill || designSystem.colors.neutral300} strokeWidth={1.75} />
        <Path d="M7.2 12H16.8" stroke={props.fill || designSystem.colors.neutral300} strokeWidth={1.75} />
    </Svg>
);
export { SvgComponent as SocialFeedIcon };
